import { createEffect, createEvent, createStore, sample } from 'effector'
import { AxiosErrorType, PromoCode, PromoCodeAttributes } from '~/shared/api'
import { mapMessageErrors } from '~/shared/lib/mapMessageErrors'
import { snackbarEnqueued } from '~/shared/lib/notifications'

export const checkPromoCodeFx = createEffect<
  { promoCode: string; driverId: string; carId: string },
  PromoCodeAttributes,
  AxiosErrorType
>({
  handler: async ({ promoCode, driverId, carId }) => {
    const promoCodeData = await PromoCode.check(promoCode)

    if (!promoCodeData.valid) {
      return promoCodeData
    }

    const validatedPromoCode = await PromoCode.validatePromocodeForDriver(
      promoCode,
      driverId,
      carId,
    )

    return {
      ...promoCodeData,
      ...validatedPromoCode,
      details: promoCodeData.details,
    }
  },
})

export const promoCodeRemoved = createEvent()

export const $validatedPromoCode = createStore<PromoCodeAttributes | null>(null)
  .on(checkPromoCodeFx.doneData, (_, data) => {
    return data.valid ? data : null
  })
  .reset(checkPromoCodeFx.failData)
  .reset(promoCodeRemoved)

sample({
  clock: checkPromoCodeFx.doneData,
  filter: (data) => data.valid,
  fn() {
    return {
      message: 'Промокод успешно применён',
      variant: 'success' as const,
    }
  },
  target: snackbarEnqueued,
})

sample({
  clock: checkPromoCodeFx.doneData,
  filter: (data) => !data.valid,
  fn() {
    return {
      message: 'Промокод недействителен',
      variant: 'danger' as const,
    }
  },
  target: snackbarEnqueued,
})

sample({
  clock: checkPromoCodeFx.failData,
  fn(e) {
    return {
      message: mapMessageErrors(e) || 'Не удалось применить промокод',
      variant: 'danger' as const,
    }
  },
  target: snackbarEnqueued,
})
